var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7533 43.9941L37.5582 5.03205C34.1529 -0.700883 25.8517 -0.7085 22.4417 5.03205L1.24768 43.9941C-2.23349 49.8522 1.98116 57.2704 8.80417 57.2704H51.1951C58.0124 57.2704 62.2345 49.8581 58.7533 43.9941ZM30 50.2391C28.0619 50.2391 26.4844 48.6615 26.4844 46.7235C26.4844 44.7854 28.0619 43.2079 30 43.2079C31.938 43.2079 33.5156 44.7854 33.5156 46.7235C33.5156 48.6615 31.938 50.2391 30 50.2391ZM33.5156 36.1766C33.5156 38.1147 31.938 39.6922 30 39.6922C28.0619 39.6922 26.4844 38.1147 26.4844 36.1766V18.5985C26.4844 16.6604 28.0619 15.0829 30 15.0829C31.938 15.0829 33.5156 16.6604 33.5156 18.5985V36.1766Z",
    fill: "#E9453A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.907b82ad7434fbf30780684bd206bf57.svg";
export { ForwardRef as ReactComponent };